import { Store } from 'react-notifications-component'

const baseOptions = {
    insert: 'top',
    container: 'top-right',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
}

/** Spec: toasts auto-dismiss at 4 seconds unless sticky. */
export const showConsolidatedToast = ({
    title,
    message,
    type = 'success',
    sticky = false,
}) => {
    Store.addNotification({
        title: title || undefined,
        message: message || '',
        type: type === 'error' ? 'danger' : type,
        ...baseOptions,
        dismiss: sticky
            ? { duration: 0, click: true, showIcon: true }
            : { duration: 4000 },
    })
}

export const ConsolidatedToasts = {
    scheduleSaved: when =>
        showConsolidatedToast({
            title: 'Schedule saved',
            message: when
                ? `First fire ${when}`
                : 'Schedule created successfully.',
            type: 'success',
        }),
    scheduleUpdated: when =>
        showConsolidatedToast({
            title: 'Schedule updated',
            message: when ? `Next fire ${when}` : 'Schedule updated successfully.',
            type: 'success',
        }),
    scheduleDeleted: () =>
        showConsolidatedToast({
            title: 'Schedule deleted',
            message: 'Run history preserved for audit.',
            type: 'success',
        }),
    scheduleHeld: () =>
        showConsolidatedToast({
            title: 'Schedule held',
            message: 'Recurring send paused. Un-hold from the list to resume.',
            type: 'success',
        }),
    scheduleResumed: when =>
        showConsolidatedToast({
            title: 'Schedule resumed',
            message: when ? `Next fire ${when}` : 'Schedule resumed.',
            type: 'success',
        }),
    testEmailSent: ({ email, reports, mode }) =>
        showConsolidatedToast({
            title: 'Test email sent',
            message: `Delivered to ${email || 'your email'}${
                reports != null ? ` — ${reports} reports included` : ''
            }${mode ? ` (${mode} mode)` : ''}.`,
            type: 'success',
        }),
    digestFired: ({ recipients, reports, runId, mode, status }) => {
        if (status && String(status).startsWith('Skipped')) {
            showConsolidatedToast({
                title: 'Digest fired',
                message: `${status} · Run #${runId}. Logged in Run History.`,
                type: 'success',
            })
            return
        }
        showConsolidatedToast({
            title: `Digest fired — sent to ${recipients ?? 0} recipients`,
            message: `${reports ?? 0} reports${mode ? ` · ${mode}` : ''} · Run #${runId}. Logged in Run History.`,
            type: 'success',
        })
    },
    saveFailed: () =>
        showConsolidatedToast({
            title: "Couldn't save schedule",
            message: 'Server error — please retry. If this persists, contact support.',
            type: 'error',
        }),
    fireNowFailed: msg =>
        showConsolidatedToast({
            title: 'Fire Now failed',
            message:
                msg ||
                'SES delivery error — see Run History for details. Recipients did not receive the email.',
            type: 'error',
        }),
    scheduleAlreadyDeleted: () =>
        showConsolidatedToast({
            title: 'Schedule not available',
            message:
                'This schedule was already deleted. Run history is kept for audit only.',
            type: 'warning',
        }),
    networkFail: () =>
        showConsolidatedToast({
            title: 'Cannot reach server',
            message: 'Check your connection and retry.',
            type: 'error',
            sticky: true,
        }),
    genericError: (title, message) =>
        showConsolidatedToast({
            title: title || 'Something went wrong',
            message: message || 'Please retry.',
            type: 'error',
        }),
}
